import { render, staticRenderFns } from "./RequestDeadlineModal.vue?vue&type=template&id=1838aeb2&"
import script from "./RequestDeadlineModal.vue?vue&type=script&lang=js&"
export * from "./RequestDeadlineModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports